import { useState, createContext, useContext, useRef, useEffect, useMemo } from "react";
import { Card, ConfirmModal, DashPopUp, DropDown } from "../../../utils/CustomComponents";
import Aside from "../Components/Aside";
import Panel from "../Components/Panel";
import { ReactComponent as Search } from "../../../img/Section/Search.svg";
import { ReactComponent as Filter } from "../../../img/Section/Filter.svg";
import { ReactComponent as Bitcoin } from "../../../img/Coins/Bitcoin.svg";
import { ReactComponent as Binance } from "../../../img/Coins/Binance.svg";
import { ReactComponent as Etherum } from "../../../img/Coins/Etherum.svg";
import { ReactComponent as XRP } from "../../../img/Coins/XRP.svg";
import { Route, Switch, useRouteMatch, NavLink, useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import Success from "../../../img/DashBoard/Succes.png";
import gsap, { Back, Expo } from "gsap";
import { useTable, useFlexLayout } from "react-table";
import { useUser } from "../../../utils/Contexts/Context";
export const PanelShadowContext = createContext();
function IndividualDashboard() {
    const match = useRouteMatch();
    const panelRef = useRef();
    const AsideRef = useRef();
    const [PanelRefState, setPanelRefState] = useState(null);
    useEffect(() => {
        setPanelRefState(panelRef);
    }, []);
    return (
        <div id="individual" className="dashboard">
            <Aside AsideRef={AsideRef} />
            <Panel panelRef={panelRef} AsideRef={AsideRef}>
                <PanelShadowContext.Provider value={PanelRefState}>
                    <Switch>
                        <Route path={`${match.path}/stake`}>
                            <Stake />
                        </Route>
                        <Route path={`${match.path}/stakings`}>
                            <Stakings />
                        </Route>
                        <Route path={`${match.path}`}>
                            <DashboardPanel />
                        </Route>
                    </Switch>
                </PanelShadowContext.Provider>
            </Panel>
        </div>
    );
}

export default IndividualDashboard;

// List of coins according to UI
// should be gotten from API

const List_of_coins = [
    {
        icon: <Bitcoin />,
        name: "BTC",
        f_name: "Bitcoin",
        market_price: {
            price: 25758.4,
            percent: +2.33,
        },
        chart_data: "",
        amount_owned: {
            amount: "0.5234000",
            dollar_eqv: "12,369.83",
        },
        amount_staked: 18351.43,
        twenty_four_perc: 1.93,
        ends_in: 15,
        current_earnings: 1850,
        duration: 3,
    },
    {
        icon: <Binance />,
        name: "BNB",
        f_name: "Binance Coin",
        market_price: {
            price: 758.4,
            percent: -1.33,
        },
        chart_data: "",
        amount_owned: {
            amount: "0.0",
            dollar_eqv: "0.00",
        },
        amount_staked: 18351.43,
        twenty_four_perc: -0.93,
        ends_in: 10,
        current_earnings: 1850,
        duration: 3,
    },
    {
        icon: <Etherum />,
        name: "ETH",
        f_name: "Etherum",
        market_price: {
            price: 3758.4,
            percent: -0.33,
        },
        chart_data: "",
        amount_owned: {
            amount: "0.0",
            dollar_eqv: "0.00",
        },
        amount_staked: 18351.43,
        twenty_four_perc: 1.93,
        ends_in: 10,
        current_earnings: 1850,
        duration: 6,
    },
    {
        icon: <XRP />,
        name: "XRP",
        f_name: "XRP",
        market_price: {
            price: 158.4,
            percent: -0.33,
        },
        chart_data: "",
        amount_owned: {
            amount: "0.0",
            dollar_eqv: "0.00",
        },
        amount_staked: 18351.43,
        twenty_four_perc: -0.93,
        ends_in: 5,
        current_earnings: 1850,
        duration: 3,
    },
];
function DashboardPanel() {
    const [Coins_List_State, setCoins_List_State] = useState(List_of_coins);
    const dashboard = useRef();
    useEffect(() => {
        const tl = gsap.timeline({ paused: true });
        tl.from(dashboard.current.children[0].children, {
            opacity: 0,
            scale: 0.7,
            stagger: { each: 0.25 },
            duration: 1,
            ease: Back.easeOut.config(1),
        })
            .from(
                dashboard.current.children[1].children[0].children,
                { opacity: 0, stagger: { each: 0.125 } },
                "-=.75"
            )
            .from(
                dashboard.current.children[1].children[1].children[0].children[0].children[0]
                    .children,
                { opacity: 0, stagger: { each: 0.125 } },
                "-=.5"
            )
            .from(dashboard.current.children[1].children[1].children[0].children[1].children, {
                opacity: 0,
                scale: 0.7,
                stagger: { each: 0.125 },
            });

        tl.play();
    }, []);

    const data = useMemo(
        () => [
            ...Coins_List_State.map(({ icon, name, market_price, chart_data, amount_owned }) => {
                const rise = market_price.percent > 0;
                return {
                    coin_name: (
                        <div className="coin_name">
                            <span
                                className="coin_icon"
                                style={{ background: name === "BTC" && "#FFB100" }}
                            >
                                {icon}
                            </span>
                            <span className="name">{name}</span>
                        </div>
                    ),
                    market_price: (
                        <div className="coin_market_price">
                            ${market_price.price.toLocaleString()}
                            <span className={`${rise ? "rise" : "fall"}`}>
                                {rise && "+"}
                                {market_price.percent}%
                            </span>
                        </div>
                    ),
                    chart: <div className="chart_data"></div>,
                    amounnt_owned: (
                        <div className="amount_owned">
                            <span className="amount_owned">
                                {amount_owned.amount.toLocaleString()}
                            </span>
                            <span className="dollar_equivalent">
                                ={amount_owned.dollar_eqv.toLocaleString()}USD
                            </span>
                        </div>
                    ),
                };
            }),
        ],
        [Coins_List_State]
    );

    const columns = useMemo(
        () => [
            {
                Header: "Coin Name",
                accessor: "coin_name", // accessor is the "key" in the data
            },
            {
                Header: "Market Price",
                accessor: "market_price",
            },
            {
                Header: "Chart",
                accessor: "chart",
            },
            {
                Header: "Amount Owned",
                accessor: "amounnt_owned",
            },
        ],
        []
    );

    const default_column = useMemo(
        () => ({
            width: 350,
        }),
        []
    );

    const tableInstance = useTable({ columns, data, default_column }, useFlexLayout);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;
    return (
        <div id="dashboard_panel" className="panel_content" ref={dashboard}>
            <div className="cards">
                <Card>
                    <div className="card_title">Total Amount</div>
                    <div className="funds">
                        <span className="dolls">$</span>
                        <span>12,369.83</span>
                    </div>
                </Card>
                <Card>
                    <div className="card_title">Investment</div>
                    <div className="funds">
                        <span className="dolls">$</span>
                        <span>7,369.83</span>
                    </div>
                </Card>
            </div>
            <div className="coins">
                <div className="utils">
                    <Card className="search" shadow="0px 4px 28px -13px rgba(0, 0, 0, 0.25)">
                        <input
                            type="text"
                            name="search_bar"
                            id="search"
                            placeholder="Search Coin"
                            onChange={({ target: { value } }) => {
                                value
                                    ? setCoins_List_State(
                                          List_of_coins.filter((coin) =>
                                              coin.name.toLowerCase().match(value.toLowerCase())
                                          )
                                      )
                                    : setCoins_List_State(List_of_coins);
                            }}
                        />
                        <Search />
                    </Card>
                    <Card
                        shadow="0px 4px 13px -5px rgba(0, 0, 0, 0.25)"
                        round={12}
                        className="filter"
                    >
                        <Filter />
                    </Card>
                </div>
                <div className="coins_table">
                    <table {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.length === 0 ? (
                                <h1 style={{ textAlign: "center", fontSize: 20 }}>
                                    No Matching coin
                                </h1>
                            ) : (
                                rows.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <td {...cell.getCellProps()}>
                                                        {cell.render("Cell")}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

function Stakings() {
    const header = useRef();
    const coins_header = useRef();
    const coins_body = useRef();
    const match = useRouteMatch();

    const View_Routes = List_of_coins.map(
        ({ id, name, icon, f_name, amount_staked, duration, ends_in, current_earnings }) => {
            const rise = current_earnings > 0;
            return (
                <Route path={`${match.path}/${id}`} exact key={id}>
                    <div className="stats_view">
                        <div style={{ overflowX: "auto" }} className="scroll">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Coin Name</th>
                                        <th>Amount Staked</th>
                                        <th>Duration</th>
                                        <th>Ends In</th>
                                        <th>Current Earnings</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="coin_name">
                                                <span
                                                    className="coin_icon"
                                                    style={{
                                                        background: name === "BTC" && "#FFB100",
                                                    }}
                                                >
                                                    {icon}
                                                </span>
                                                <div>
                                                    <span className="f_name">{f_name}</span>
                                                    <span className="name">{name}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td>${amount_staked.toLocaleString()}</td>
                                        <td>{duration} months</td>
                                        <td>{ends_in} days</td>
                                        <td>
                                            <span className={`${rise ? "rise" : "fall"}`}>
                                                {rise ? "+" : "-"}{" "}
                                                {current_earnings.toLocaleString()}%
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="graph">Coin Graph Here.</div>
                    </div>
                </Route>
            );
        }
    );
    return (
        <div id="dashboard_panel" className="panel_content stakings">
            <Switch>
                {View_Routes}
                <Route path={match.path}>
                    <StakingsMainPage />
                </Route>
            </Switch>
        </div>
    );

    function StakingsMainPage() {
        useEffect(() => {
            const tl = gsap.timeline({ paused: true });
            tl.from(header.current.children, {
                opacity: 0,
                scale: 0.7,
                stagger: { each: 0.125 },
                duration: 1,
                ease: Back.easeOut.config(2),
            })
                .from(
                    coins_header.current.children,
                    { opacity: 0, stagger: { each: 0.125 } },
                    "-=1"
                )
                .from(
                    coins_body.current.children,
                    {
                        opacity: 0,
                        scale: 0.7,
                        stagger: { each: 0.125 },
                    },
                    "-=.1"
                );

            tl.play();
        }, []);
        return (
            <>
                <header ref={header}>
                    <NavLink to={match.url} activeClassName="active" exact>
                        Active Stakings
                    </NavLink>
                    <span></span>
                    <NavLink to={`${match.url}/closed_stakings`} activeClassName="active">
                        Closed Stakings
                    </NavLink>
                </header>
                <div className="coins">
                    <div className="coins_table">
                        <Route path={`${match.path}/closed_stakings`}>
                            <ClosedStakings />
                        </Route>
                        <Route path={`${match.path}`} exact>
                            <ActiveStakings />
                        </Route>
                    </div>
                </div>
            </>
        );
        function ClosedStakings() {
            const data = useMemo(
                () => [
                    ...List_of_coins.map(({ id, icon, name, amount_staked, duration, ends_in }) => {
                        return {
                            coin_name: (
                                <div className="coin_name">
                                    <span
                                        className="coin_icon"
                                        style={{ background: name === "BTC" && "#FFB100" }}
                                    >
                                        {icon}
                                    </span>
                                    <span className="name">{name}</span>
                                </div>
                            ),
                            amount_staked: (
                                <div className="coin_market_price">
                                    ${amount_staked.toLocaleString()}
                                </div>
                            ),
                            duration: <div className="ends_in">{duration} months</div>,
                            total_earnings: (
                                <div className="total_earnings">
                                    ${amount_staked.toLocaleString()}
                                </div>
                            ),
                        };
                    }),
                ],
                []
            );

            const columns = useMemo(
                () => [
                    {
                        Header: "Coin Name",
                        accessor: "coin_name", // accessor is the "key" in the data
                    },
                    {
                        Header: "Amount Staked",
                        accessor: "amount_staked",
                    },
                    {
                        Header: "Duration",
                        accessor: "duration",
                    },
                    {
                        Header: "Total Earnings",
                        accessor: "total_earnings",
                    },
                ],
                []
            );

            const default_column = useMemo(
                () => ({
                    width: 350,
                }),
                []
            );

            const tableInstance = useTable({ columns, data, default_column }, useFlexLayout);
            const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
                tableInstance;
            return (
                <div className="closed">
                    <table {...getTableProps()}>
                        <thead ref={coins_header}>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody ref={coins_body} {...getTableBodyProps()}>
                            {rows.length === 0 ? (
                                <h1 style={{ textAlign: "center", fontSize: 20 }}>
                                    No Matching coin
                                </h1>
                            ) : (
                                rows.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <td {...cell.getCellProps()}>
                                                        {cell.render("Cell")}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            );
        }
        function ActiveStakings() {
            const data = useMemo(
                () => [
                    ...List_of_coins.map(
                        ({ id, icon, name, amount_staked, twenty_four_perc, ends_in }) => {
                            const rise = twenty_four_perc > 0;
                            return {
                                coin_name: (
                                    <div className="coin_name">
                                        <span
                                            className="coin_icon"
                                            style={{ background: name === "BTC" && "#FFB100" }}
                                        >
                                            {icon}
                                        </span>
                                        <span className="name">{name}</span>
                                    </div>
                                ),
                                amount_staked: (
                                    <div className="coin_market_price">
                                        ${amount_staked.toLocaleString()}
                                    </div>
                                ),
                                twenty_four_perc: (
                                    <span className={`${rise ? "rise" : "fall"}`}>
                                        {rise && "+"}
                                        {twenty_four_perc}%
                                    </span>
                                ),
                                ends_in: <div className="ends_in">{ends_in} Days</div>,
                                view: (
                                    <div className="view">
                                        <NavLink to={`${match.url}/${id}`}>
                                            <button className="btn_pry">View</button>
                                        </NavLink>
                                    </div>
                                ),
                            };
                        }
                    ),
                ],
                []
            );

            const columns = useMemo(
                () => [
                    {
                        Header: "Coin Name",
                        accessor: "coin_name", // accessor is the "key" in the data
                    },
                    {
                        Header: "Amount Staked",
                        accessor: "amount_staked",
                    },
                    {
                        Header: "24hr %",
                        accessor: "twenty_four_perc",
                    },
                    {
                        Header: "Ends in",
                        accessor: "ends_in",
                        width: 100,
                    },
                    {
                        Header: "",
                        accessor: "view",
                    },
                ],
                []
            );

            const default_column = useMemo(
                () => ({
                    width: 350,
                }),
                []
            );

            const tableInstance = useTable({ columns, data, default_column }, useFlexLayout);
            const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
                tableInstance;
            return (
                <div className="active">
                    <table {...getTableProps()}>
                        <thead ref={coins_header}>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody ref={coins_body} {...getTableBodyProps()}>
                            {rows.length === 0 ? (
                                <h1 style={{ textAlign: "center", fontSize: 20 }}>
                                    No Matching coin
                                </h1>
                            ) : (
                                rows.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (
                                                    <td {...cell.getCellProps()}>
                                                        {cell.render("Cell")}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            );
        }
    }
}

function Stake() {
    const [PopUp, setPopUp] = useState(false);
    const [Confirm_modal, setConfirm_modal] = useState(false);
    const List_of_coins = useMemo(
        () => [
            {
                id: 1,
                icon: <Bitcoin />,
                name: "BTC",
                f_name: "Bitcoin",
            },
            {
                id: 2,
                icon: <Binance />,
                name: "BNB",
                f_name: "Binance Coin",
            },
            {
                id: 3,
                icon: <Etherum />,
                name: "ETH",
                f_name: "Etherum",
            },
            {
                id: 4,
                icon: <XRP />,
                name: "XRP",
                f_name: "XRP",
            },
        ],
        []
    );
    const [SelectedCryptoToInvest, setSelecedCryptoToInvest] = useState("BTC");
    const [AmountToInvest, setAmountToInvest] = useState("100");
    const [TimeToInvest, setTimeToInvest] = useState(3);
    // const { user } = useUser();
    const panelRef = useContext(PanelShadowContext);
    const history = useHistory();
    const control1 = useRef();
    const control2 = useRef();
    const control3 = useRef();
    const button = useRef();
    useEffect(() => {
        const tl = gsap.timeline();
        tl.from([...[control1, control2, control3].map((ct) => ct.current.children[0])], {
            opacity: 0,
            y: 50,
            duration: 0.5,
        })
            .from(
                [...[control1, control2, control3].map((ct) => ct.current.children[1])],
                {
                    opacity: 0,
                    scale: 0.7,
                    stagger: { each: 0.25 },
                    ease: Back.easeOut.config(1),
                },
                "-=.25"
            )
            .from(
                [button.current],
                {
                    opacity: 0,
                    y: 10,
                    stagger: { each: 0.25 },
                },
                "-=.5"
            );
    }, []);
    const currency_symbol = useRef();
    const [Currency, setCurrency] = useState("USD");
    useEffect(() => {
        switch (Currency) {
            case "USD":
                currency_symbol.current.innerHTML = "$";
                break;
            case "EURO":
                currency_symbol.current.innerHTML = "&euro; ";
                break;
            case "POUNDS":
                currency_symbol.current.innerHTML = "&#163; ";
                break;
            default:
                currency_symbol.current.innerHTML = "$";
        }
    }, [Currency]);
    const coinsRender = List_of_coins.map(({ icon, name }) => ({
        render: (
            <div className="coin_option">
                <div className="icon">
                    {name === "BTC" ? <div className="bitcoin">{icon}</div> : icon}
                </div>
                <div className="name">{name}</div>
            </div>
        ),
        value: name,
    }));
    const {
        user: { id },
    } = useUser();
    function invest() {
        if (!AmountToInvest) return toast.error("Please input the amount you want to invest!");
        let payload = {
            user: id,
            coin: SelectedCryptoToInvest,
            amount: AmountToInvest,
            time: TimeToInvest,
            currency: Currency,
        };
        setPopUp(true);
        panelRef.current.classList.remove("shadow");
    }
    return (
        <div id="dashboard_panel" className="stake">
            <div className="control_wrapper">
                <div className="control">
                    <div className="control_item" ref={control1}>
                        <header>
                            <h3>Select Crypto Currency To Stake On</h3>
                        </header>
                        <Card round={12} shadow="0px 4px 28px -13px rgba(0, 0, 0, 0.25)">
                            <DropDown
                                header="Select Coin to Invest"
                                removeOnExit={true}
                                dropListArray={coinsRender}
                                index={3}
                                icon={(function () {
                                    var coin = List_of_coins.find(
                                        ({ name }) => name === SelectedCryptoToInvest
                                    );
                                    return (
                                        <div className="selected_render">
                                            <div className="icon">
                                                {coin.name === "BTC" ? (
                                                    <div className="bitcoin">{coin.icon}</div>
                                                ) : (
                                                    coin.icon
                                                )}
                                            </div>
                                            <div className="icon_name">
                                                <div className="f_name">{coin.f_name}</div>
                                                <div className="name">{coin.name}</div>
                                            </div>
                                        </div>
                                    );
                                })()}
                                setOption={setSelecedCryptoToInvest}
                            />
                        </Card>
                    </div>
                    <div className="control_item" ref={control2}>
                        <header>
                            <h3>Stakings Amount</h3>
                        </header>
                        <Card
                            round={12}
                            className="staking_amount"
                            shadow="0px 4px 28px -13px rgba(0, 0, 0, 0.25)"
                        >
                            <div className="input_feild">
                                <span ref={currency_symbol}></span>
                                <input
                                    type="number"
                                    name=""
                                    id=""
                                    value={AmountToInvest.toLocaleString()}
                                    onChange={({ target: { value } }) => {
                                        setAmountToInvest(value.toLocaleString());
                                    }}
                                />
                            </div>
                            <span className="divider"></span>
                            <DropDown
                                header="Select Currency"
                                removeOnExit={true}
                                index={2}
                                dropListArray={[
                                    { render: "USD" },
                                    { render: "EURO" },
                                    { render: "POUNDS" },
                                ]}
                                initialOption={Currency}
                                setOption={setCurrency}
                                width="auto"
                            />
                        </Card>
                    </div>
                    <div className="control_item" ref={control3}>
                        <header>
                            <h3>Duration</h3>
                        </header>
                        <Card round={12} shadow="0px 4px 28px -13px rgba(0, 0, 0, 0.25)">
                            <DropDown
                                index={1}
                                initialOption={`${TimeToInvest} ${
                                    TimeToInvest === 1 ? "month" : "months"
                                }`}
                                header="Select Time Frame"
                                setOption={setTimeToInvest}
                                removeOnExit
                                dropListArray={[1, 2, 3, 6, 8, 12].map((c) => ({
                                    render: `${c} ${c === 1 ? "month" : "months"}`,
                                    value: c,
                                }))}
                                customClassNames="time_drop_down"
                            />
                        </Card>
                    </div>
                </div>
                <button
                    ref={button}
                    className="cta btn btn_pry"
                    onClick={() => {
                        setConfirm_modal(true);
                    }}
                >
                    Invest
                </button>
            </div>
            <DashPopUp state={PopUp}>
                <SuccessFeedback />
            </DashPopUp>
            <ConfirmModal state={Confirm_modal} control={setConfirm_modal}>
                <div className="content">
                    Are you sure you want to stake ${AmountToInvest} on the selected coin?
                </div>
                <div className="cta_btn">
                    <button
                        onClick={() => {
                            invest();
                            setConfirm_modal(false);
                        }}
                    >
                        Yes
                    </button>
                    <button onClick={() => setConfirm_modal(false)}>No</button>
                </div>
            </ConfirmModal>
        </div>
    );

    function SuccessFeedback() {
        const img = useRef();
        const text = useRef();
        useEffect(() => {
            const tl = gsap.timeline();
            tl.from(img.current, {
                scale: 0,
                duration: 2,
                ease: Expo.easeOut,
            }).from(text.current.children, { y: 20, opacity: 0, stagger: { each: 0.25 } }, "-=1");
        }, []);
        return (
            <div id="success_investment">
                <img src={Success} alt="success" ref={img} />
                <div style={{ display: "grid", gap: "3vh" }} ref={text}>
                    <h3>Investment Succesful</h3>
                    <p>
                        Inspect the progress of the crypto currency you invested on from your
                        dashboard
                    </p>
                    <button
                        className="btn btn_pry"
                        onClick={() => {
                            setPopUp(false);
                            panelRef && panelRef.current.classList.add("shadow");
                            history.goBack();
                        }}
                    >
                        Continue To Dashboard
                    </button>
                </div>
            </div>
        );
    }
}
